import React, { FormEvent } from "react";
import AppIcons from "../../utils/AppIcons";

interface IFormInputCheckboxProps {
  label: string;
  id: string;
  checked: boolean | undefined;
  required?: boolean | undefined;
  details?: string;
  onChange: (id: string, value: boolean) => void;
  error?: string | undefined;
  css_label?: string | undefined;
}

function FormInputCheckbox({
  label,
  id,
  checked,
  required,
  details,
  onChange,
  error,
  css_label,
}: IFormInputCheckboxProps) {
  return (
    <div key={"key_" + id}>
      {label && (
        <label htmlFor={id} className={css_label ? css_label : "form-label"}>
          {label}
          {required && <>*</>}
        </label>
      )}
      <label className="cursor-pointer" onClick={(e) => onChange(id, !checked)}>
        <div className="form-checkbox">{checked && AppIcons.CHECK} </div>
        {details}
      </label>
      <input
        className="hidden"
        type="checkbox"
        name={id}
        id={id}
        checked={checked}
        required={required}
        onChange={() => {}}
      />
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}

export default FormInputCheckbox;
